/**
 * Institution country allowlist (ISO 3166-1 alpha-2) on organizations/{orgId}.
 * Keep in sync with functions/src/organizations/institutionCountry.js
 *
 * Intentionally small: US and KE are the current operating countries.
 * Do not expand this list without an explicit product decision.
 */
export const COUNTRIES = [
  { value: "US", label: "United States" },
  { value: "KE", label: "Kenya" },
];

export const COUNTRY_CODES = COUNTRIES.map((c) => c.value);

/** UI sentinel for unset (Firestore stores null). */
export const COUNTRY_UNSET = "";

export function isValidCountryCode(value) {
  if (value == null || value === COUNTRY_UNSET) return true;
  return typeof value === "string" && COUNTRY_CODES.includes(value);
}

/** Absent / unknown / empty → null. Valid codes are uppercased. */
export function normalizeCountryCode(value) {
  if (typeof value !== "string") return null;
  const code = value.trim().toUpperCase();
  return COUNTRY_CODES.includes(code) ? code : null;
}

export function countryLabel(value) {
  const code = normalizeCountryCode(value);
  if (!code) return "Not set";
  return COUNTRIES.find((c) => c.value === code)?.label || code;
}
